import React, { useState, useEffect, useContext, Component } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet';
import Header from '../components/Header'
import Footer from '../components/Footer';
import axiosInstance from '../../axiosInstance';
import HeaderPage from '../components/HeaderPage';
import LoadingScreen from '../components/LoadingScreen';

const Page = () => {
  const [loading, setloading] = useState(true);

  const [Page, setPage] = useState({});
  const { slug } = useParams();


  const getBlog = async () => {
    setloading(true);
    try {
      const { data } = await axiosInstance.get(`/admin/get-page/${slug}`);
      setPage(data.Mpage);

      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }


  };




  useEffect(() => {
    getBlog();
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <>

      <HeaderPage title={!loading ? Page.title || 'Not Found' : ''} />

      <main className="page-content  mypadding overflow-auto pb-4" >
        <div className="px-3">
          {!loading ?
            <div dangerouslySetInnerHTML={{ __html: Page.description }} />
            : <LoadingScreen />
          }

        </div>
      </main>

    </>

  )
}

export default Page